/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { IconDotsVertical, IconDownload, IconPlus, IconPrinter, IconSearch, IconX } from "@tabler/icons-react";

import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import ToggleButton from "../../../components/ToggleButton";
import { usePermission } from "../../../hooks/usePermissionTabs";
import { useForm } from "react-hook-form";

import {
  useUpdateVehicleStatus,
  useVehicleCreateMutation,
  useVehicleListData,
} from "../../../apis/fleetApis";
import toast from "react-hot-toast";
import NewCommonModal from "../../../components/common/NewCommonModal";
import NoDataFound from "../../../components/common/NoDataFound";
import Pagination from "../../../components/common/Pagination";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import useDebounce from "../../../utilities/useDebounce";
import EntriesSelector from "../../../components/common/EntriesSelector";
import { useSelector } from "react-redux";
import GenerateInvoice from "./GenerateInvoice";
import ViewModal from "./ViewModal";
import CommonModal from "../../../components/common/CommonModal";
import PayAdjust from "./PayAdjust";
import { useLanguage } from "../../../context/LanguageContext";

const data = {
  invoices: [
    {
      id: "1a05b005-2fd1-4bb1-a8e8-9ca2b9527b8f",
      invoiceId: "INV12344",
      clientName: "Sameer Khan",
      email: "sameer@mailinator.com",
      amount: "400",
      invoiceType: "COD Invoice",
      date: "4 Aug 2025",
      paymentType: "CO",
      status: "Paid",
      download: "Download",
      active: true,
    },
    {
      id: "34d1d096-5c89-4202-b57c-69c10f4f8c12",
      invoiceId: "INV12346",
      clientName: "Rohi Saxena",
      email: "rohitsaxena@mailinator.com",
      amount: "200",
      invoiceType: "COD Invoice",
      date: "4 Aug 2025",
      paymentType: "COD",
      status: "Unpaid",
      download: "Downloading....",
      active: false,
    },
    {
      id: "34d1d096-5c89-4202-b57c-69c10f4f8c12",
      invoiceId: "INV12345",
      clientName: "Ramesh G",
      email: "sarah@example.com",
      amount: "100",
      invoiceType: "COD Invoice",
      paymentType: "COD",
      date: "4 Aug 2025",
      status: "Unpaid",
      download: "Download",
      active: false,
    },
  ],
  total: 12,
  page: 1,
  totalPages: 2,
};

type FormValues = {
  clientId: string;
  shipmentId: string[];
  rcNumber: string;
  invoiceType: string;
  paymentType: string;
  endDate: string;
  closeDate: string;
};

const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <div className="flex justify-between items-center w-full py-1">
    <div className="w-full">
      <h2 className="capitalize text-[#212121] text-xs font-semibold">{label}</h2>
    </div>
    <div className="w-full">
      <p className="text-[#1E293B] text-xs">{value}</p>
    </div>
  </div>
);

interface Props {
  setHeaderButtons?: (node: React.ReactNode) => void;
}

const InvoiceManagement: React.FC<Props> = ({ setHeaderButtons }) => {
  const { t } = useLanguage();
  const { allowed: canCreateInvoice } = usePermission("invoices", "create");
  const { allowed: canUpdateInvoice } = usePermission("invoices", "update");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);

  const [openPayAdjust, setOpenPayAdjust] = useState<boolean>(false);
  const openPayAdjustToggleModal = () => {
    setOpenPayAdjust(!openPayAdjust);
  };

  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };

  const { refetch, isLoading } = useVehicleListData(pageNo, limit, searchFor);

  // const data = useSelector((state: any) => state?.invoice?.data);

  console.log("datadatadatadatadatadata", data);

  const { mutate: updateVehicleStatus, isPending: activePending } =
    useUpdateVehicleStatus();
  const { mutate: createVehicle, isPending: createPending } =
    useVehicleCreateMutation();

  const [invoiceData, setVehicleData] = useState(data);

  useEffect(() => {
    if (data) setVehicleData(data);
  }, [data]);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit]);

  const [modals, setModals] = useState({
    add: false,
    edit: false,
    assign: false,
    view: false,
    confirmStatus: false,
  });

  const toggleModal = (modalName: keyof typeof modals, value?: boolean) => {
    setModals((prev) => ({
      ...prev,
      [modalName]: value !== undefined ? value : !prev[modalName],
    }));
  };

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  const openAddModal = () => toggleModal("add", true);
  const closeAddModal = () => {
    toggleModal("add", false);
    reset();
  };

  useEffect(() => {
    if (!setHeaderButtons) return;
    setHeaderButtons(null);
    return () => {
      setHeaderButtons(null);
    };
  }, [setHeaderButtons]);

  const openViewModal = (invoice: any) => {
    setSelectedInvoice(invoice);
    toggleModal("view", true);
  };
  const closeViewModal = () => {
    toggleModal("view", false);
    setSelectedInvoice(null);
  };

  const handleCreateInvoice = (data: any) => {
    if (!canCreateInvoice) {
      toast.error(t("You do not have permission to create invoices"));
      return;
    }
    createVehicle(
      { ...data },
      {
        onSuccess: () => {
          closeAddModal();
          // refetch();
          toast.success(t("Vehicle Added Successfully."));
        },
        onError: (error) => toast.error(`${error}`),
      }
    );
  };

  const [columnsData, setColumnsData] = useState([
    { text: "S/N", value: "sn", isShow: true },
    { text: "Client Name", value: "clientName", isShow: true },
    { text: "Email", value: "email", isShow: true },
    { text: "Date", value: "date", isShow: true },
    { text: "Invoice Type", value: "invoiceType", isShow: true },
    { text: "Payment Type", value: "paymentType", isShow: true },
    { text: "Amount", value: "amount", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Download", value: "download", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col
      )
    );
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "sn":
          return {
            label: t("S/N"),
            render: (_: any, i: number) => (pageNo - 1) * limit + (i + 1),
          };
        case "clientName":
          return { label: t("Client Name"), render: (c: any) => c.clientName };
        case "email":
          return { label: t("Email"), render: (c: any) => c.email };
        case "date":
          return { label: t("Date"), render: (c: any) => c.date };
        case "invoiceType":
          return { label: t("Invoice Type"), render: (c: any) => t(c.invoiceType) };
        case "paymentType":
          return { label: t("Payment Type"), render: (c: any) => t(c.paymentType) };
        case "amount":
          return {
            label: t("Amount"),
            render: (c: any) => <div>{c.amount}</div>,
          };
        case "status":
          return {
            label: t("Status"),
            render: (c: any) => {
              const isAssigned = c.status === "Paid";
              const statusClasses = isAssigned
                ? "bg-[#E6F7E8] border border-[#20BF55] text-[#212121]"
                : "bg-[#FF4848]/10 border border-[#FF4848] text-[#212121]";
              return (
                <div className="flex justify-center">
                  <button
                    className={`rounded-full w-24 px-4 text-xs font-medium py-1.5 text-center ${statusClasses}`}
                  >
                    {t(c.status)}
                  </button>
                </div>
              );
            },
          };
        case "download":
          return {
            label: t("Download"),
            render: (c: any) => (
              <button className="bg-[#ffffff] border border-[#d2d2d2] px-2 py-1 rounded-full">
                {t(c.download)}
              </button>
            ),
          };
        case "actions":
          return {
            label: t("Actions"),
            render: (s: any) => (
              <div className="relative text-center">
                <button
                  onClick={() =>
                    setOpenDropdownIndex(openDropdownIndex === s ? null : s)
                  }
                  className="p-2 border rounded-full bg-[#F7F6F2]"
                >
                  <IconDotsVertical size={22} />
                </button>

                {openDropdownIndex === s && (
                  <div
                    ref={dropdownRef}
                    className="absolute bg-[#F7F6F2] divide-y right-14 text-left -top-16 z-50 mt-2 w-fit whitespace-nowrap rounded-xl shadow-lg overflow-hidden"
                  >
                    <div
                      className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                      onClick={() => openViewModal(s)}
                    >
                      {t("View Details")}
                    </div>
                    {canUpdateInvoice && (
                      <div
                        className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                        onClick={openPayAdjustToggleModal}
                      >
                        {t("Pay Adjust")}
                      </div>
                    )}
                    <div
                      className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                      onClick={openShelveToggleModal}
                    >
                      {t("Print")}
                    </div>
                  </div>
                )}
              </div>
            ),
          };
        default:
          return { label: "", render: () => null };
      }
    });

  const isAnySidePanelOpen = modals.add || modals.view || openPayAdjust;

  return (
    <div className="grid grid-cols-12 gap-6 p-2 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-ful rounded-tr-3xl rounded-b-3xl w-full">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

      <div
        className={
          isAnySidePanelOpen
            ? "col-span-12 xl:col-span-7 space-y-4 min-w-0"
            : "col-span-12 space-y-4 min-w-0"
        }
      >
        <div className="bg-white rounded-tr-3xl rounded-b-3xl overflow-visible mb-6">
          {/* Header Row (Filters + Actions Unified) */}
          <div className="px-6 py-3.5 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
            
            {/* Left side: Empty */}
            <div className="flex flex-wrap items-center gap-3"></div>

            {/* Right side: Export + Search + Advanced Filters */}
            <div className="flex items-center flex-wrap gap-2.5">
              {/* Sliding Search */}
              <div className="relative flex items-center">
                <div
                  onClick={() => {
                    if (!showSearch) {
                      setShowSearch(true);
                    }
                  }}
                  className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-lg bg-white shadow-sm h-8 ${
                    showSearch ? "w-64 px-2 cursor-default" : "w-8 justify-center cursor-pointer hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95"
                  }`}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowSearch(!showSearch);
                    }}
                    className="flex items-center justify-center text-slate-700 focus:outline-none flex-shrink-0"
                    title={t("Search")}
                  >
                    <IconSearch size={17} stroke={2.5} />
                  </button>
                  {showSearch && (
                    <>
                      <input
                        type="text"
                        value={searchFor}
                        onChange={(e) => {
                          setSearchFor(e.target.value);
                          setPageNo(1);
                        }}
                        placeholder={t("Search...")}
                        autoFocus
                        className="flex-1 ml-2 bg-transparent text-xs text-slate-800 placeholder-slate-400 outline-none border-none"
                      />
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSearchFor("");
                          setShowSearch(false);
                        }}
                        className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                        title={t("Clear & Close")}
                      >
                        <IconX size={14} stroke={2.5} />
                      </button>
                    </>
                  )}
                </div>
              </div>

              {/* Export */}
              <button
                className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                title={t("Export to Excel")}
              >
                <IconDownload size={17} stroke={2.5} />
              </button>

              {/* Entries limit selector */}
              {invoiceData && invoiceData.totalPages * limit > 10 && (
                <EntriesSelector
                  value={limit}
                  options={[
                    10,
                    ...(invoiceData.totalPages * limit > 10 ? [20] : []),
                    ...(invoiceData.totalPages * limit > 20 ? [30] : []),
                    ...(invoiceData.totalPages * limit > 50 ? [50] : []),
                    ...(invoiceData.totalPages * limit > 100 ? [100] : []),
                  ]}
                  onChange={(val) => {
                    setLimit(val);
                    setPageNo(1);
                  }}
                />
              )}

              {/* Columns Filter */}
              <ColumnsFilter
                columnsData={columnsData.map(c => ({ ...c, text: t(c.text) }))}
                setHeadings={setHeadings}
              />

              {/* Dropdown Filter */}
              <DropdownFilter
                filterheadings={[]}
                triggerClassName="border border-slate-200 bg-white rounded-lg cursor-pointer text-[#212121] hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150 h-8 w-8 flex items-center justify-center shadow-sm select-none"
                iconSize={17}
              />

              {/* Add Invoice */}
              {canCreateInvoice && (
                <button
                  onClick={openAddModal}
                  className="w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-150 border border-[#FBD037] bg-[#FBD037] text-[#131327] hover:bg-[#e2bd30] shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer"
                  title={t("Add Invoice")}
                >
                  <IconPlus size={17} stroke={2.5} />
                </button>
              )}
            </div>
          </div>

          {/* Table */}
          <div className="border-t border-slate-100">
            {isLoading ? (
              <TableSkeleton
                columns={columnsData.filter((c) => c.isShow).map((c) => t(c.text))}
                rows={6}
              />
            ) : invoiceData?.invoices && invoiceData?.invoices.length > 0 ? (
              <ListView
                data={invoiceData?.invoices}
                onRowClick={(vehicle) => console.log("Clicked:", vehicle)}
                columns={columns}
                mainDivClassName="bg-white"
                mailDivClassName="p-0"
              />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
        <div className="py-4 flex justify-center">
          {invoiceData?.totalPages > 1 && (
            <Pagination
              totalPages={invoiceData?.totalPages}
              currentPage={pageNo}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
      </div>

      {isAnySidePanelOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-30 xl:hidden"
            onClick={() => {
              if (modals.add) closeAddModal();
              if (modals.view) closeViewModal();
              if (openPayAdjust) setOpenPayAdjust(false);
            }}
          />
          <div className="col-span-12 xl:col-span-5 relative mt-2 xl:static fixed inset-y-0 right-0 z-[35] w-full sm:w-[450px] xl:w-auto p-4 pt-[76px] sm:pt-[96px] xl:p-0 shadow-2xl xl:shadow-none bg-white xl:bg-transparent overflow-y-auto xl:overflow-visible flex flex-col justify-start min-h-[500px]">
            
            {/* View Details Modal (Takes top priority in the sidebar) */}
            {modals.view && (
              <div className="relative rounded-3xl shadow-sm border border-gray-200/50 flex flex-col overflow-hidden bg-transparent w-full">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200/50 bg-transparent">
                  <h2 className="text-xl font-semibold text-[#212121]">{t("View Invoice")} – {selectedInvoice?.invoiceId}</h2>

                  <div className="flex items-center gap-2">
                    <button className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition-all duration-150 shadow-sm hover:shadow active:scale-95 cursor-pointer">
                      <IconPrinter size={17} stroke={2.5} />
                    </button>
                    <button className="w-8 h-8 flex items-center justify-center bg-[#FBD037] hover:bg-[#e2bd30] border border-[#FBD037] text-[#131327] rounded-lg transition-all duration-150 shadow-sm hover:shadow active:scale-95 cursor-pointer">
                      <IconDownload size={17} stroke={2.5} />
                    </button>
                    <button
                      onClick={closeViewModal}
                      className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#D2D2D2] hover:bg-slate-50 cursor-pointer"
                    >
                      <IconX size={18} />
                    </button>
                  </div>
                </div>

                <div className="p-6 overflow-y-auto max-h-[calc(100vh-140px)] bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-2xl border border-[#ECECEC] m-6 shadow-sm space-y-4">
                  <InfoRow label={t("Customer")} value={selectedInvoice?.clientName} />
                  <InfoRow
                    label={t("Invoice Type")}
                    value={t(selectedInvoice?.invoiceType)}
                  />
                  <InfoRow label={t("Date")} value={selectedInvoice?.date} />
                  <InfoRow label={t("Type")} value="COD" />
                  <InfoRow label={t("Amount")} value={selectedInvoice?.amount} />
                  <InfoRow label={t("Shipments")} value="240" />
                  <InfoRow label={t("Due Date")} value={selectedInvoice?.date} />
                  <div className="flex justify-between items-center w-full">
                    <div className="w-full">
                      <h2 className="capitalize text-[#212121] text-xs font-semibold">
                        {t("Status")}
                      </h2>
                    </div>
                    <div className="w-full flex items-center gap-2">
                      {selectedInvoice?.status === "Paid" ? (
                        <button className="rounded-full w-24 px-3 py-1 text-center text-xs font-semibold bg-[#E6F7E8] border border-[#20BF55] text-[#212121]">
                          {t("Paid")}
                        </button>
                      ) : (
                        <button className="rounded-full w-24 px-3 py-1 text-center text-xs font-semibold bg-[#FF4848]/10 border border-[#FF4848] text-[#212121]">
                          {t("Unpaid")}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Pay Adjust Modal (Takes second priority) */}
            {!modals.view && openPayAdjust && (
              <div className="relative rounded-3xl shadow-sm border border-gray-200/50 flex flex-col overflow-hidden bg-transparent w-full">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200/50 bg-transparent">
                  <h2 className="text-xl font-semibold text-[#212121]">{t("Pay Adjust")}</h2>

                  <div className="flex items-center gap-3">
                    <button
                      onClick={openPayAdjustToggleModal}
                      className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-slate-50 cursor-pointer"
                    >
                      <IconX size={20} />
                    </button>
                  </div>
                </div>

                <div className="p-6 overflow-y-auto max-h-[calc(100vh-200px)] bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-2xl border border-[#ECECEC] m-6 shadow-sm">
                  <PayAdjust />
                </div>

                <div className="border-t border-[#D8D8D8]/50 px-6 py-4 flex justify-end gap-2.5 bg-transparent">
                  <button
                    onClick={openPayAdjustToggleModal}
                    className="border border-[#D8D8D8] bg-white text-[#212121] rounded-lg p-2 px-4 cursor-pointer text-sm font-medium hover:bg-slate-50 active:scale-95 transition-all shadow-sm"
                  >
                    {t("Cancel")}
                  </button>
                  <button
                    onClick={openPayAdjustToggleModal}
                    className="bg-[#FBD037] rounded-lg p-2 px-6 text-[#212121] text-sm font-bold hover:bg-[#e2bd30] active:scale-95 transition-all shadow-sm"
                  >
                    {t("Confirm")}
                  </button>
                </div>
              </div>
            )}

            {/* Generate Invoice (Add Modal - Rendered only when both View and Pay Adjust are closed) */}
            {!modals.view && !openPayAdjust && modals.add && (
              <div className="relative rounded-3xl shadow-sm border border-gray-200/50 flex flex-col overflow-hidden bg-transparent w-full">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200/50 bg-transparent">
                  <h2 className="text-xl font-semibold text-[#212121]">{t("Generate Invoice")}</h2>

                  <div className="flex items-center gap-3">
                    <button
                      onClick={handleSubmit(handleCreateInvoice)}
                      disabled={createPending}
                      className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg font-bold hover:bg-[#e2bd30] active:scale-95 transition-all duration-150 cursor-pointer text-sm shadow-sm"
                    >
                      {createPending ? t("Adding...") : t("Add")}
                    </button>

                    <button
                      onClick={closeAddModal}
                      className="p-2 rounded-lg border border-[#D2D2D2] hover:bg-slate-50 cursor-pointer"
                    >
                      <IconX size={20} />
                    </button>
                  </div>
                </div>

                <div className="p-6">
                  <GenerateInvoice
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    clearErrors={clearErrors}
                    control={control}
                    selectedOrders={selectedOrders}
                    setSelectedOrders={setSelectedOrders}
                  />
                </div>
              </div>
            )}

          </div>
        </>
      )}
    </div>
  );
};

export default InvoiceManagement;
